import styled from 'styled-components'

export const Container = styled.section`
  margin-top: -10rem;
  margin-bottom: 10rem;
  padding: 4rem 2rem;
  text-align: center;
  position: relative;
  z-index: 1;

  h2 {
    font-size: 4rem;
    margin-bottom: 1rem;
    color: var(--green);
  }

  p {
    font-size: 1.8rem;
    color: #b3b3b3;
    margin-bottom: 2rem;
  }

  .server-info {
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid var(--green);
    border-radius: 8px;
    padding: 2rem;
    max-width: 600px;
    margin: 2rem auto;
    backdrop-filter: blur(5px);
  }

  /* --- PERUBAHAN DI SINI --- */
  
  /* Wrapper baru untuk Ikon + MOTD */
  .motd-container {
    background: #1e1e1e;
    padding: 1.5rem;
    border-radius: 4px;
    margin-bottom: 2rem;
    display: flex; /* <-- Mengatur ikon & MOTD berdampingan */
    align-items: center; /* <-- Menengahkan secara vertikal */
    gap: 1.5rem; /* <-- Jarak antara ikon & MOTD */
  }

  /* Style untuk Ikon Server */
  .server-icon {
    width: 64px;
    height: 64px;
    border-radius: 4px;
    image-rendering: pixelated; /* <-- Menjaga agar ikon pixelated tetap tajam */
    flex-shrink: 0; /* <-- Mencegah ikon menyusut */
  }

  /* Style MOTD disesuaikan agar pas di dalam flex container */
  .motd {
    background: none; /* <-- Latar belakang dipindahkan ke parent */
    padding: 0; /* <-- Padding dipindahkan ke parent */
    border-radius: 0;
    text-align: left;
    font-family: 'Minecraftia', monospace, sans-serif;
    white-space: pre-wrap;
    margin-bottom: 0; /* <-- Dihapus, diatur oleh parent */
    line-height: 1.5;
    overflow-wrap: break-word;
    flex: 1; /* <-- Mengisi sisa ruang */

    span[style] {
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
    }
  }

  /* --- AKHIR PERUBAHAN --- */

  .details-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
  }

  .detail-item {
    background: rgba(0, 0, 0, 0.2);
    padding: 1.2rem;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.6rem;
    overflow: hidden;

    span {
      color: #b3b3b3;
      white-space: nowrap;
      margin-right: 8px;
    }

    strong {
      color: #ffffff;
    }
  }

  .status-display {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .status-indicator {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    flex-shrink: 0;
    
    &.online {
      background-color: #4caf50;
      box-shadow: 0 0 8px #4caf50;
    }

    &.offline {
      background-color: #f44336;
      box-shadow: 0 0 8px #f44336;
    }
  }

  .copy-button,
  .map-link-button {
    background-color: var(--green);
    color: #fff;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    transition: background-color 0.2s;
    font-size: 1.4rem;
    text-decoration: none;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      filter: brightness(0.9);
    }

    &.copied {
      background-color: #4caf50;
    }
  }

  .map-link-button {
    background-color: #016fb9; // Biru
  }

  .optional-links {
    margin-top: 2rem;
    padding-top: 2rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  .optional-links h4 {
    font-size: 1.8rem;
    color: var(--green);
    margin-bottom: 1.5rem;
    font-weight: 600;
    text-align: left;
  }

  .links-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
  }

  .link-button {
    background-color: #333;
    color: #fff;
    border: 1px solid #555;
    padding: 1rem 1.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s;
    font-size: 1.5rem;
    text-decoration: none;
    display: block;

    &:hover {
      filter: brightness(1.2);
      border-color: var(--green);
    }

    &.installer {
      background-color: #f39c12;
      border-color: #f39c12;
      &:hover {
        filter: brightness(0.9);
      }
    }

    &.tutorial {
      background-color: #9b59b6;
      border-color: #9b59b6;
      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`